import { useMutation } from 'react-query';
import http from '../http';
import { MerchantConnectCreateUpdateStampCardPayload } from './types';

// to update stamp card on merchant connect
const merchantConnectUpdateStampCard = ({
  payload,
  loyaltySettingsId,
}: UpdateFavePassPayload) =>
  http.put<MerchantConnectCreateUpdateStampCardPayload>(
    `/v1/mc_products/${loyaltySettingsId}`,
    payload,
  );

export const useMerchantConnectUpdateStampCard = () =>
  useMutation(merchantConnectUpdateStampCard);

type UpdateFavePassPayload = {
  payload: FormData;
  loyaltySettingsId: string;
};
